export function estoquePostosInRequest(params = {}) {
  return {
    type: '@operacaoestoqueposto/ESTOQUEPOSTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findEstoquePosto(id) {
  return {
    type: '@operacaoestoqueposto/FIND_ESTOQUEPOSTO',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoestoqueposto/FAILED_REQUEST',
  };
}

export function deleteEstoquePosto(id, params) {
  return {
    type: '@operacaoestoqueposto/DELETE_ESTOQUEPOSTO',
    payload: { id, params },
  };
}

export function updateEstoquePosto(data, params) {
  return {
    type: '@operacaoestoqueposto/UPDATE_ESTOQUEPOSTO',
    payload: { data, params },
  };
}

export function storeEstoquePosto(data, params) {
  return {
    type: '@operacaoestoqueposto/STORE_ESTOQUEPOSTO',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@operacaoestoqueposto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@operacaoestoqueposto/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoestoqueposto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoestoqueposto/RECORD_FILTERING',
    payload: { params },
  };
}

export function resetFiltering(params = {}) {
  return {
    type: '@operacaoestoqueposto/RESET_FILTERING',
    payload: { params },
  };
}
